import DashboardsWrapperPage from './DashboardsWrapperPage';

export default DashboardsWrapperPage;
